import React from "react";

export const MicrosoftIcon = ({ className = "w-5 h-5" }) => {

  return (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 0L7.09421 1.28049V7.64349H16V0ZM6.46685 1.37101L0 2.301V7.64349H6.46685V1.37101ZM0 8.262V13.6725L6.46685 14.6135V8.262H0ZM7.09421 8.262V14.705L16 16V8.26202L7.09421 8.262Z" fill="#0A0A0A" />
    </svg>
  );
  
};

